import {createContext, useContext, useEffect, useReducer} from "react";
import {initialState, reducer, setDetail, setLoading, setOrderComment, setPayModalVisible} from "./reducer";
import {useQueryParam} from "../../../../hooks";
import {useCancelOrder, useGetOrderInfoById} from "../../../../api/orderBase";
import {config, deepClone} from "../../../../utils";
import cookies from "../../../../utils/cookies";
import useNotice from "../../../../hooks/useNotice";
import Dialog from "../../../../publicComponent/Dialog";
import {useTranslation} from "react-i18next";
import {useBatchAddComment} from "../../../../api/shopItemComment";
import {useNavigateTo} from "../../../../hooks/useNavigateTo";

const Context = createContext(initialState);

function OrderDetailController() {
  const { addCommentHandle } = useBatchAddComment();
  const { state, dispatch } = useOrderDetailContext();
  const { loading, getDetail } = useGetOrderInfoById();
  const { cancelOrder } = useCancelOrder();
  const [orderId] = useQueryParam('orderId');
  const [orderNo] = useQueryParam('orderNo');
  const [payTypeParams] = useQueryParam('payType');
  const { detail } = state;
  const { t } = useTranslation();
  const notice = useNotice();
  const agentInfo = cookies.getAgentInfo();
  const navigateTo = useNavigateTo();
  
  /**
   * 获取预约订单详情
   * @returns {Promise<void>}
   */
  const getOrderDetail = async () => {
    if (!orderId || !orderNo) {
      notice.error('订单不存在！');
    }
    let { data } = await getDetail({ orderId, orderNo });
    if (data) {
      dispatch(setDetail(data));
    }
  };
  
  const selectPayType = (payType) => {
    const data = detail;
    let isMul = 0;
    let url = config.PAYMENT_HOST;
    let domain = window.location.hostname;
    
    if (data.subOrderId && data.subOrderId.split(',').length > 1) {
      isMul = 1;
    }
    
    let urlQuery = `?orderId=${data.orderId}&isMulOrder=${isMul}&tk=${cookies.getToken()}&doMainName=${domain}&isFromPC=1`;
    payType = `${payType}`;
    if (payType === '1') {
      url += `payment/Stripe.html${urlQuery}`;
      window.open(url, '_blank');
    }
    
    if (payType === '2') {
      url += `payment/Paypal.html${urlQuery}&aliasName${cookies.get('aliasName')}`;
      window.open(url, '_blank');
    }
    
    if (payType === '5') {
      Dialog.qrcode({
        title: 'PayMe支付',
        qrcode: agentInfo.paymeQrUrlView
      });
      return;
    }
    
    dispatch(setPayModalVisible(false));
  };

  const gotoPayMethods = () => {
    const data = detail;
    let isMul = 0;
    let url = config.PAYMENT_HOST;
    let domain = window.location.hostname;
    
    if (data.subOrderId && data.subOrderId.split(',').length > 1) {
      isMul = 1;
    }

    let urlQuery = `?orderId=${data.orderId}&isMulOrder=${isMul}&tk=${cookies.getToken()}&doMainName=${domain}&isFromPC=1`;
    // payType = `${payTypeParams}`;
    if (payTypeParams === '1') {
      url += `payment/Stripe.html${urlQuery}`;
      window.open(url, '_blank');
    }
    
    if (payTypeParams === '2') {
      url += `payment/Paypal.html${urlQuery}&aliasName${cookies.get('aliasName')}`;
      window.open(url, '_blank');
    }
  }
  
  const cancelOrderHandle = async () => {
    Dialog.confirm({
      content: t('确定要取消订单吗？'),
      onOk: async (onClose) => {
        let { data } = await cancelOrder({ orderId });
        if (data) {
          notice.success(t('取消成功'));
          getOrderDetail();
        }
        onClose();
      }
    });
  };
  
  const _setPayModalVisible = (visible) => {
    dispatch(setPayModalVisible(visible));
  };
  
  
  const getOrderDetailComment = async () => {
    if (!orderId || !orderNo) {
      notice.error('订单不存在！');
    }
    let { data } = await getDetail({ orderId, orderNo });
    if (data) {
      dispatch(setDetail(data));
      if (data.productList.length > 0) {
      
      }
      let orderComment = data.productList.map(item => {
        return {
          comment: '',
          grade: 0,
          starNum: -1,
          itemId: item.itemId,
          orderId,
        };
      });
      
      dispatch(setOrderComment(orderComment));
    }
  };
  
  const starHandle = (star, index) => {
    let orderComment = [...state.orderComment];
    orderComment[index].starNum = star;
    dispatch(setOrderComment(orderComment));
  };
  
  const gradeHandle = (grade, index) => {
    let orderComment = [...state.orderComment];
    orderComment[index].grade = grade;
    dispatch(setOrderComment(orderComment));
  };
  
  const commentHandle = (value, index) => {
    let orderComment = [...state.orderComment];
    orderComment[index].comment = value;
    dispatch(setOrderComment(orderComment));
  };
  
  const submitComment = async () => {
    let query = deepClone(state.orderComment);
    
    if (query.find(item => item.starNum === -1)) {
      return notice.warn('请为商品评星');
    }
    
    query.forEach((item) => item.starNum += 1);
    
    let { data } = await addCommentHandle(query);
    
    if (data) {
      notice.success('评价成功');
      setTimeout(() => {
        navigateTo('/orderList');
      }, 1200);
    }
    
  };
  
  useEffect(() => {
    dispatch(setLoading(loading));
  }, [loading]);
  
  return {
    getOrderDetail,
    selectPayType,
    cancelOrderHandle,
    gotoPayMethods,
    getOrderDetailComment,
    starHandle,
    gradeHandle,
    commentHandle,
    submitComment,
    setPayModalVisible: _setPayModalVisible
  };
  
}

function useOrderDetailContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useOrderDetailContext, OrderDetailController};

export default function OrderDetailContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
